import styled from 'styled-components';

export const FilterContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 0 1.5rem 1.375rem 1.5rem;
`;

export const FormContainer = styled.div`
  display: flex;
  width: 100%;
  column-gap: 1rem;
  align-items: flex-end;
  line-height: 1rem;

  & .input-wrapper {
    width: 35rem;
  }

  & button {
    width: 12rem;
    height: 2.8125rem;
  }
`;
